import { SubtitleEntry } from "../types";
import * as SrtParser from "srt-parser-2";

/**
 * Parse an SRT file content into structured data
 * @param {string} srtContent - Raw content of the SRT file
 * @returns {SubtitleEntry[]} Array of subtitle objects
 */
export const parseSRT = (srtContent: string): SubtitleEntry[] => {
  try {
    // Create a new parser instance
    const parser = new SrtParser.default();

    // Parse the SRT content
    const parsedSubtitles = parser.fromSrt(srtContent);

    // Convert the library's format to your app's format
    return parsedSubtitles.map((sub: any) => ({
      id: Number(sub.id),
      startTime: sub.startTime,
      endTime: sub.endTime,
      text: sub.text,
    }));
  } catch (error) {
    console.error("Error parsing SRT file:", error);
    return [];
  }
};
